export enum Civil3dFeatureType {
  COGO_POINT = 'COGO Point',
  AUTOCAD_POINT = 'AutoCAD Point',
  FEATURE_LINE = 'Feature Line',
  FEATURE_LINE_2D = '2D Polyline',
  FEATURE_LINE_3D = '3D Polyline',
  ALIGNMENT = 'Alignment',
  PARCEL = 'Parcel',
}

export enum Civil3dFeatureTypeCategory {
  COGO_POINT = Civil3dFeatureType.COGO_POINT,
  FEATURE_LINE = Civil3dFeatureType.FEATURE_LINE,
  ALIGNMENT = Civil3dFeatureType.ALIGNMENT,
  PARCEL = Civil3dFeatureType.PARCEL,
}

export const civil3dFeatureTypesByCategory: Record<Civil3dFeatureTypeCategory, Civil3dFeatureType[]> = {
  [Civil3dFeatureType.COGO_POINT]: [Civil3dFeatureType.COGO_POINT, Civil3dFeatureType.AUTOCAD_POINT],
  [Civil3dFeatureType.FEATURE_LINE]: [
    Civil3dFeatureType.FEATURE_LINE,
    Civil3dFeatureType.FEATURE_LINE_2D,
    Civil3dFeatureType.FEATURE_LINE_3D,
  ],
  [Civil3dFeatureType.ALIGNMENT]: [
    Civil3dFeatureType.ALIGNMENT,
    Civil3dFeatureType.FEATURE_LINE_2D,
    Civil3dFeatureType.FEATURE_LINE_3D,
  ],
  [Civil3dFeatureType.PARCEL]: [Civil3dFeatureType.PARCEL],
} as const;
